(function () {
  'use strict';
  QueryStringService.$inject = [ '$location' ];
  angular.module('MktzapApp.Directives')
    .service('QueryStringService', QueryStringService);

  function QueryStringService ($location) {
    this.getFilters = function (filterObj) {
      var qs = $location.search();
      for (var param in filterObj) {
        if (param in qs) {
          filterObj[param] = qs[param].trim();
		            }
		        }
		        if (qs.length == 0) {
		        	return filterObj;
		        }
		        return filterObj;
		    };
  }
})();
